export default __webpack_public_path__ + "static/media/hourglass_top.3db88255.svg";